<template>
  <div class="acsidebar shadow-lg" v-show="sidebarloaded===true">
    <div class="text-center sidebarpl" v-show="sidebarenabled===false">
      <p><button @click="doUnCollapse" class="btn-transparent"><font-awesome-icon icon="bars" aria-label="Expand Sidebar"></font-awesome-icon></button></p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p><router-link :to="{name: 'climyaccount', params: { id: clientID }}"><font-awesome-icon icon="user" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'cliinbox', params: { id: clientID }}" v-show="isDisabled"><font-awesome-icon icon="envelope" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'clitutorials', params: { id: clientID }}" v-show="isDisabled"><font-awesome-icon icon="book" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'clinotifications', params: { id: clientID }}" v-show="isDisabled"><font-awesome-icon icon="flag" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'clireports', params: { id: clientID }}"  v-show="!isLifelineUser"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'clitrainingplans', params: { id: clientID }}" v-show="isDisabled"><font-awesome-icon icon="project-diagram" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'clicertificates', params: { id: clientID }}" v-show="isDisabled"><font-awesome-icon icon="user-graduate" role="presentation"></font-awesome-icon></router-link></p>
    </div>
    <div v-show="sidebarenabled===true" class="sidebarpl">
      <button @click="doCollapse" class="btn-transparent" style="margin-left:-15%"><font-awesome-icon icon="bars" aria-label="Collapse Sidebar"></font-awesome-icon></button>
      <h3>{{clientShortName}}</h3>
      <div class="sidebarlinks" v-if="clientID!==null">
        <p><router-link :to="{name: 'climyaccount', params: { id: clientID }}" name="my_account"><font-awesome-icon icon="user" role="presentation"></font-awesome-icon> My Account</router-link></p>
        <p><router-link :to="{name: 'cliinbox', params: { id: clientID }}" name="inbox" v-show="isDisabled"><font-awesome-icon icon="envelope" role="presentation"></font-awesome-icon> Inbox</router-link></p>
        <p><router-link :to="{name: 'clitutorials', params: { id: clientID }}" name="tutorials" v-show="isDisabled"><font-awesome-icon icon="book" role="presentation"></font-awesome-icon> Tutorials</router-link></p>
        <p><router-link :to="{name: 'clinotifications', params: { id: clientID }}" name="notifications" v-show="isDisabled"><font-awesome-icon icon="flag" role="presentation"></font-awesome-icon> Notifications</router-link></p>
        <p><router-link :to="{name: 'clireports', params: { id: clientID }}" name="reports" v-show="!isLifelineUser"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon> Reports</router-link></p>
        <p><router-link :to="{name: 'clitrainingplans', params: { id: clientID }}" name="training_plans" v-show="isDisabled"><font-awesome-icon icon="project-diagram" role="presentation"></font-awesome-icon> Training Plans</router-link></p>
        <p><router-link :to="{name: 'clicertificates', params: { id: clientID }}" name="certificates" v-show="isDisabled"><font-awesome-icon icon="user-graduate" role="presentation"></font-awesome-icon> Certificates</router-link></p>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OrgSidebar',
    data() {
      return {
        clientShortName: null,
        clientID: null,
        sidebarenabled: null,
        sidebarloaded: false,
        isLifelineSSO: true,
      }
    },
    methods: {
      doCollapse() {
        this.sidebarenabled = false;
        this.collapseSidebar();
      },
      doUnCollapse() {
        this.sidebarenabled = true;
        this.deCollapseSidebar();
      }
    },
    mounted() {

      this.$bus.$on("ClientSidebarUpdateEvent", (cliShortName, cliID, isenabled) => {
        this.clientShortName = cliShortName;
        this.clientID = cliID;

        if (typeof (isenabled) !== "undefined" && isenabled === false) {
          this.sidebarenabled = false;
          var self = this;
          window.setTimeout(function () {
            self.collapseSidebar();
            self.sidebarloaded = true;
          }, 100);
        }
        else {
          this.sidebarloaded = true;
          this.sidebarenabled = true;
        }
      });


      setTimeout("Window.loadLanguageContent()", 500);
    },
    computed: {
      isDisabled() {
        let flag = true;
        if (sessionStorage.getItem("isSimmersionUser")) {
          var sdata = localStorage.getItem("sdata");
          if (sdata != null) {
            var all_pools = JSON.parse(sdata).allpools;
            var all_groups = JSON.parse(sdata).allgroups;
            if (all_pools.length > 0) {
              for (var i = 0; i < all_pools.length; i++) {
                if (all_pools[i].LicensePoolID == '91961f0a-b004-43a6-967d-32b36ddd66b0') {
                  flag = false;
                  break;
                }
              }
            }
            if (all_groups.length > 0 && flag == true) {
              for (var i = 0; i < all_groups.length; i++) {
                if (all_groups[i].LicensePoolID == '91961f0a-b004-43a6-967d-32b36ddd66b0') {
                  flag = false;
                  break;
                }
              }
            }
          }
        }
        return flag;
      },

      isLifelineUser() {
        return sessionStorage.getItem('isLifelineUser') === 'true';
      }
    }
  }
</script>
